exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.search-form[data-v-5dfe1a00] {\n  height: 64px;\n  float: none;\n}\n.domain-section dd[data-v-5dfe1a00] {\n  padding-top: 4px;\n  padding-bottom: 4px;\n  color: #8a2be2;\n}\n.domain-section dt[data-v-5dfe1a00] {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5dfe1a00","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/Domain.vue
// module id = 374
// module chunks = 1